import Vue from 'vue'
import Vuex from 'vuex'

import { ubic } from '@/core/store';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: '0',

    /* User */
    // userName: null,
    // userEmail: null,
    // userAvatar: null,

    /* NavBar */
    isNavBarVisible: true,

    /* FooterBar */
    isFooterBarVisible: true,

    /* Aside */
    isAsideVisible: true,
    isAsideExpanded: true,
    isAsideMobileExpanded: false,

    activeSubmenu: null,
  },
  mutations: {
    /* A fit-them-all commit */
    basic (state, payload) {
      (state as any)[payload.key] = payload.value
    },

    /* User */
    // user (state, payload) {
    //   if (payload.name) {
    //     state.userName = payload.name
    //   }
    //   if (payload.email) {
    //     state.userEmail = payload.email
    //   }
    //   if (payload.avatar) {
    //     state.userAvatar = payload.avatar
    //   }
    // },

    /* Aside Mobile */
    asideMobileStateToggle (state, payload = null) {
      const htmlClassName = 'has-aside-mobile-expanded'

      let isShow

      if (payload !== null) {
        isShow = payload
      } else {
        isShow = !state.isAsideMobileExpanded
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName)
      } else {
        document.documentElement.classList.remove(htmlClassName)
      }

      state.isAsideMobileExpanded = isShow
    },

    /* Aside Mobile */
    asideStateToggle (state, payload = null) {
      const htmlClassName = 'has-aside-expanded'

      let isShow

      if (payload !== null) {
        isShow = payload
      } else {
        isShow = !state.isAsideExpanded
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName)
      } else {
        document.documentElement.classList.remove(htmlClassName)
      }

      state.isAsideExpanded = isShow
    },

    openSubmenu (state, payload = null) {
      state.activeSubmenu = payload;
    },

    hideSubmenu (state, payload = null) {
      state.activeSubmenu = null;
    }
  },
  actions: {
  },
  modules: {
    ubic
  },
})